import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function Button({ children, variant = "primary", size = "md", icon, disabled, onClick, fullWidth, type = "button", style: extraStyle = {} }) {
  const sizes = {
    xs: { padding: "4px 12px",  fontSize: 11, borderRadius: 6 },
    sm: { padding: "6px 16px",  fontSize: 12, borderRadius: 7 },
    md: { padding: "9px 22px",  fontSize: 13, borderRadius: 8 },
    lg: { padding: "13px 30px", fontSize: 14, borderRadius: 9 },
  };
  const base = {
    display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6,
    border: "none", cursor: disabled ? "not-allowed" : "pointer",
    fontFamily: font.body, fontWeight: 600, letterSpacing: "0.01em",
    transition: "all 0.15s ease", opacity: disabled ? 0.45 : 1,
    width: fullWidth ? "100%" : undefined, outline: "none",
    ...sizes[size],
  };
  const variants = {
    primary: {
      background: `linear-gradient(135deg, ${t.navy}, ${t.navyLight})`,
      color: t.goldLight,
      boxShadow: `0 2px 10px ${t.shadow}`,
    },
    secondary: {
      background: t.surface, color: t.textPrimary,
      border: `1.5px solid ${t.border}`,
      boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    },
    ghost: {
      background: "transparent", color: t.textSecondary,
    },
    danger: {
      background: t.coralLight, color: t.coral,
      border: `1.5px solid ${t.coral}40`,
    },
    amber: {
      background: t.amberLight, color: t.amber,
      border: `1.5px solid ${t.amber}40`,
    },
    cta: {
      background: t.textPrimary, color: "#fff",
      fontWeight: 700, letterSpacing: "0.06em",
      fontSize: 12, textTransform: "uppercase",
      boxShadow: "0 2px 10px rgba(17,24,39,0.25)",
    },
    outline: {
      background: "transparent", color: t.textPrimary,
      border: `2px solid ${t.textPrimary}`,
    },
  };
  const hoverClass = variant === "primary" ? "rf-primary" : variant === "ghost" ? "rf-ghost" : "rf-sec";

  return (
    <button
      type={type}
      className={hoverClass}
      style={{ ...base, ...variants[variant], ...extraStyle }}
      disabled={disabled}
      onClick={onClick}
    >
      {icon && <span>{icon}</span>}
      {children}
    </button>
  );
}

export function IconButton({ icon, color = t.emerald, size = 34, label, onClick }) {
  return (
    <button
      title={label}
      className="rf-ibtn"
      onClick={onClick}
      style={{
        width: size, height: size, borderRadius: "50%",
        background: `${color}18`,
        border: "none",
        cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: size * 0.44, color,
        transition: "all 0.15s", flexShrink: 0, outline: "none",
      }}
    >{icon}</button>
  );
}
